import { withAuth } from 'hocs/auth/with-auth';
import { Invitation as InvitationPage } from './invitation';

// Signing in is optional: signed out, accepting goes through sign in or up.
const Invitation = withAuth(InvitationPage, true);

export { Invitation };
